'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$9() {
  this.bw0 = null;
  this.bw1 = false;
}
export { $c_Lpresto_RegisterPageView$$anon$9 as $c_Lpresto_RegisterPageView$$anon$9 };
$p = $c_Lpresto_RegisterPageView$$anon$9.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$9;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$9() {
}
export { $h_Lpresto_RegisterPageView$$anon$9 as $h_Lpresto_RegisterPageView$$anon$9 };
$h_Lpresto_RegisterPageView$$anon$9.prototype = $p;
$p.P = (function() {
  if ((!this.bw1)) {
    this.bw0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aE()));
    this.bw1 = true;
  }
  return this.bw0;
});
var $d_Lpresto_RegisterPageView$$anon$9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$9, "presto.RegisterPageView$$anon$9", ({
  Qg: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$9 as $d_Lpresto_RegisterPageView$$anon$9 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$9.js.map
